import React from 'react'
import { PrintOrderDetailListPage } from '../../../components/templates/reusable-orders/print/print-order-detail-list-page'

export const ReusableDeliveryList = () => {
  return <PrintOrderDetailListPage title="VIXELL Order Note" />
}
